import React from 'react'
import { useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import ModuleAudienceCard from './components/ModuleAudienceCard'
import Section from './components/Section'
import { OPERATION_PRODUCT_ANALYTICS_MOBILE_PRIVATE_WIFI } from './operations-gql/queries'
import { MobilePrivateWifiQuery, ProductAnalyticsPeriod, ProductAnalyticsVariables } from './types'

type MobilePrivateWifiSectionProps = {
  period: ProductAnalyticsPeriod
}

const TRANSLATION_PREFIX = 'stats.product_analytics.private_wifi'

const MobilePrivateWifiSection: React.FC<MobilePrivateWifiSectionProps> = ({ period }) => {
  const { t } = useTranslation()
  const { data, loading, error } = useQuery<MobilePrivateWifiQuery, ProductAnalyticsVariables>(
    OPERATION_PRODUCT_ANALYTICS_MOBILE_PRIVATE_WIFI,
    { variables: { period }, errorPolicy: 'all' }
  )
  const audience = data?.productAnalytics?.privateWifiAudience

  return (
    <Section id="product-analytics-mobile-private-wifi" title={t(`${TRANSLATION_PREFIX}.title`)} columns={{ xs: 1, md: 3 }}>
      <ModuleAudienceCard
        description={t(`${TRANSLATION_PREFIX}.mobile_audience_description`)}
        audience={audience}
        loading={loading}
        hasError={Boolean(error) && !audience}
        viewsLabel={t('stats.product_analytics.module_audience.screen_views')}
      />
    </Section>
  )
}

export default MobilePrivateWifiSection
